import order from './../../../services/purchase/order.js';
import orderList from './orderList'

export default {
    namespaced: true,
    modules: {
        orderList
    },
    actions: {
        findByID(context, payload) {
            return new Promise((resolve, reject) => {
                order.findByID(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            });
        },
        create(context, payload) {
            return new Promise((resolve, reject) => {
                order.create(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            });
        },
        update(context, payload) {
            return new Promise((resolve, reject) => {
                order.update(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            });
        },
        close(context, payload) {
            return new Promise((resolve, reject) => {
                order.close(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            });
        },
        remove(context, payload){
            return new Promise((resolve, reject) => {
                order.remove(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        }
    }
}